import styled from "styled-components";

const LinkItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding: 0.5rem 0 0.5rem 1rem;
`;

const LinkText = styled.span`
  font: ${props => props.theme.typography.fontFamily};
  font-weight: 600;
  font-size: 1.3rem;
  color: ${props => props.color ?? props.theme.colors.textColor};
  margin-left: 1.5rem;
`;

export { LinkItemWrapper, LinkText };
